














// Products Family List Table Headers
export const productFamilyListTableHeaders = [
    {
        fieldDisplayName: "Country Name",
        fieldName: "countryId.name",
    },
    {
        fieldDisplayName: "Company Name",
        fieldName: "oilCompanyId.name",
    },
    {
        fieldDisplayName: "Name",
        fieldName: "name",
    },
    {
        fieldDisplayName: "Short Name",
        fieldName: "shortName",
    },
    
];






export const expertFieldsData = [
    // {
    //     fieldDisplayName: "Expert Image",
    //     fieldName: "expertImage",
    //   },
    {
        fieldDisplayName: "Name",
        fieldName: "expertName",
      },
    {
      fieldDisplayName: "Contact Number",
      fieldName: "phone",
    },
    // {
    //   fieldDisplayName: "Email",
    //   fieldName: "email",
    // },
    // {
    //   fieldDisplayName: "TPF Member",
    //   fieldName: "tpfMember",
    // },
    
    {
      fieldDisplayName: "Domain",
      fieldName: "domain",
    },
    {
      fieldDisplayName: "SubDomain",
      fieldName: "subDomain",
    },
   
    
    
  ];
export const expertTableData = [
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,

        "expertName": "Dr. Tushar",
        "contactNumber": "9845342867",
        "email": "Tushar@gmail.com",
        "tpfMember": "Yes",
        "domain": "Medical Aid",
        "subDomain": "Heart",
        
    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,

        "expertName": "Dr.Mehta",
        "contactNumber": "7865342321",
        "email": "Mehta@gmail.com",
        "tpfMember": "No",
        "domain": "Medical Aid",
        "subDomain": "Kidney",
        
    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,

        "expertName": "Adv. Sahib Singh",
        "contactNumber": "8786452345",
        "email": "SahibSingh@gmail.com",
        "tpfMember": "Yes",
        "domain": "Legal Consultation",
        "subDomain": "Property",
        
    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,

        "expertName": "ADV Raman",
        "contactNumber": "8987654539",
        "email": "raman@gmail.com",
        "tpfMember": "Yes",
        "domain": "Legal Consultation",
        "subDomain": "Will",
        
    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,

        "expertName": "Rima Yadav",
        "contactNumber": "9897654879",
        "email": "rima@gmail.com",
        "tpfMember": "No",
        "domain": "Taxation Guide",
        "subDomain": "Income Tax",
        
    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,

        "expertName": "Ranjan jha",
        "contactNumber": "7896439856",
        "email": "ranjan@gmail.com",
        "tpfMember": "No",
        "domain": "Taxation Guide",
        "subDomain": "GST",
        
    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,

        "expertName": "Mohan Agarwal",
        "contactNumber": "9876548671",
        "email": "agrawalmohan@gmail.com",
        "tpfMember": "Yes",
        "domain": "Career Conselling",
        "subDomain": "Admissions",
        
    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,

        "expertName": "Ravi Malhotra",
        "contactNumber": "8534656589",
        "email": "ravi@gmail.com",
        "tpfMember": "Yes",
        "domain": "Career Conselling",
        "subDomain": "Institutes",
        
    },
    
  ];
export const expertuserSlotFieldData = [
    {
        fieldDisplayName: "Booking Id",
        fieldName: "_id",
      },
    {
        fieldDisplayName: "User Name",
        fieldName: "userName",
      },
    {
        fieldDisplayName: "Expert Name",
        fieldName: "expertName",
      },
    {
      fieldDisplayName: "Slot Time",
      fieldName: "slotTime",
    },
    {
      fieldDisplayName: "Slot Date",
      fieldName: "slotDate",
    },
    {
      fieldDisplayName: "Slot Mode",
      fieldName: "mode",
    },
    {
      fieldDisplayName: "Location",
      fieldName: "location",
    },
    // {
    //   fieldDisplayName: "Booked Shift",
    //   fieldName: "shiftName",
    // },
   
    {
      fieldDisplayName: "Status",
      fieldName: "bookingStatus",
    },
    
  ];
export const expertLocSlotFieldData = [
  {
    fieldDisplayName: "Date",
    fieldName: "slotDate",
  },
  {
    fieldDisplayName: "Location Name",
    fieldName: "locationName",
  },
  {
    fieldDisplayName: "Expert Name",
    fieldName: "expertName",
  },
  {
    fieldDisplayName: "Domain Name",
    fieldName: "expertDomain",
  },
  {
    fieldDisplayName: "Sub-Domain Name",
    fieldName: "expertSubDomain",
  },
 
  {
    fieldDisplayName: "Morning Slot",
    fieldName: "morningSlot",
  },
  {
    fieldDisplayName: "Afternoon Slot",
    fieldName: "afternoonSlot",
  },
  {
    fieldDisplayName: "Evening Slot",
    fieldName: "eveningSlot",
  },
 
  {
    fieldDisplayName: "Night Slot",
    fieldName: "nightSlot",
  },
    
  ];
export const expertuserSlotTableData = [
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "userImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,

        "userName": "Sanjeev",
        "slotBookDate": "02 Dec 2024",
        "bookedShift": "Morning Shift (07:00 AM - 10:59 AM)",
        "bookedSlotNo": "07:30 AM to 07:45 AM",
        "bookingStatus": "Completed",
        
        
    },
   
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "userImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,


        "userName": "Vikram jeet Singh",
        "slotBookDate": "05 Dec 2024",
        "bookedShift": "Evening Shift (03:00 PM - 06:59 AM)",
        "bookedSlotNo": "04:30 PM to 04:45 PM",
        "bookingStatus": "Active",
        
        
    },
   
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "userImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,


        "userName": "Deepak jha",
        "slotBookDate": "07 Dec 2024",
        "bookedShift": "Afternoon Shift (11:00 AM - 02:59 AM)",
        "bookedSlotNo": "12:30 PM to 12:45 PM",
        "bookingStatus": "Cancelled",
        
        
    },
   
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "userImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,


        "userName": "Sanjeev",
        "slotBookDate": "05 Dec 2024",
        "bookedShift": "Night Shift (07:00 PM - 10:00 PM)",
        "bookedSlotNo": "07:30 PM to 07:45 PM",
        "bookingStatus": "Active",
        
        
    },
   
    
    
  ];
export const userFieldsData = [
    // {
    //     fieldDisplayName: "User Image",
    //     fieldName: "userImage",
    //   },
    {
        fieldDisplayName: "Name",
        fieldName: "username",
      },
    {
      fieldDisplayName: "Contact Number",
      fieldName: "phone",
    },
    // {
    //   fieldDisplayName: "Email",
    //   fieldName: "email",
    // },
    {
      fieldDisplayName: "Age",
      fieldName: "age",
    },
    
    
  ];
export const userTableData = [
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "userImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,
        "userName": "Arvin",
        "userContactNumber": "7505363305",
        "email": "arvin@gmail.com",
        "userAge": "28 Years",
        
    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "userImage": <img className="user-profile-img" src='https://picsum.photos/id/237/200/300' />,
        
        "userName": "Lokendra",
        "userContactNumber": "9896363305",
        "email": "lokendra@gmail.com",
        "userAge": "32 Years",

    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "userImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,
       
        "userName": "manoj",
        "userContactNumber": "9895126705",
        "email": "manoj@gmail.com",
        "userAge": "38 Years",
        
    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "userImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,

        "userName": "Pravin",
        "userContactNumber": "7623143567",
        "email": "pravin@gmail.com",
        "userAge": "31 Years",
        
    },
    
   
    
  ];
export const userSlotFieldData = [
    {
        fieldDisplayName: "Booking Id",
        fieldName: "_id",
      },
    {
        fieldDisplayName: "User Name",
        fieldName: "userName",
      },
    {
        fieldDisplayName: "Expert Name",
        fieldName: "expertName",
      },
    {
      fieldDisplayName: "Slot  Time",
      fieldName: "slotTime",
    },
    {
      fieldDisplayName: "Slot Date",
      fieldName: "slotDate",
    },
    {
      fieldDisplayName: "Slot Mode",
      fieldName: "mode",
    },
    {
      fieldDisplayName: "Location",
      fieldName: "location",
    },
    // {
    //   fieldDisplayName: "Booked Shift",
    //   fieldName: "shiftName",
    // },
   
    {
      fieldDisplayName: "Status",
      fieldName: "bookingStatus",
    },
    
  ];
export const userSlotTableData = [
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,

        "expertName": "Sanjeev",
        "slotBookDate": "02 Dec 2024",
        "bookedShift": "Morning Shift (07:00 AM - 10:59 AM)",
        "bookedSlotNo": "07:30 AM to 07:45 AM",
        "bookingStatus": "Completed",
        
        
    },
   
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,

        "expertName": "Vikram jeet Singh",
        "slotBookDate": "05 Dec 2024",
        "bookedShift": "Evening Shift (03:00 PM - 06:59 AM)",
        "bookedSlotNo": "04:30 PM to 04:45 PM",
        "bookingStatus": "Active",
        
        
    },
   
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,

        "expertName": "Deepak jha",
        "slotBookDate": "07 Dec 2024",
        "bookedShift": "Afternoon Shift (11:00 AM - 02:59 AM)",
        "bookedSlotNo": "12:30 PM to 12:45 PM",
        "bookingStatus": "Cancelled",
        
        
    },
   
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,

        "expertName": "Sanjeev",
        "slotBookDate": "05 Dec 2024",
        "bookedShift": "Night Shift (07:00 PM - 10:00 PM)",
        "bookedSlotNo": "07:30 PM to 07:45 PM",
        "bookingStatus": "Active",
        
        
    },
   
    
  ];
export const userBookSlotFieldData = [
    {
        fieldDisplayName: "Expert Profile",
        fieldName: "expertProfile",
      },
    // {
    //   fieldDisplayName: "Expert Name",
    //   fieldName: "expertName",
    // },
    // {
    //   fieldDisplayName: "Expert Domain",
    //   fieldName: "expertDomain",
    // },
    // {
    //   fieldDisplayName: "Expert Sub Domain",
    //   fieldName: "expertSubDomain",
    // },
    // {
    //   fieldDisplayName: "Experience",
    //   fieldName: "experience",
    // },
   
    // {
    //   fieldDisplayName: "Available Slots",
    //   fieldName: "availableSlots",
    // },
    
    
  ];
export const userBookSlotTableData = [
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,
        "expertName": "Dr. Mehta",
        "expertDomain": "Medical Aid",
        "expertSubDomain": "Heart",
        "experience": "5 ",
        "expertReview": "3",
       
        "availableSlots": "07:00 AM , 08:45 AM",
        
        
    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,
        "expertName": "Dr. Mehta",
        "expertDomain": "Medical Aid",
        "expertSubDomain": "Heart",
        "experience": "5 ",
       
        "availableSlots": "07:00 AM to 07:15 AM , 08:45 AM to 09:00 AM ",
        
        
    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,
        "expertName": "Dr. Mehta",
        "expertDomain": "Medical Aid",
        "expertSubDomain": "Heart",
        "experience": "5 ",
       
        "availableSlots": "07:00 AM to 07:15 AM , 08:45 AM to 09:00 AM ",
        
        
    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,
        "expertName": "Dr. Mehta",
        "expertDomain": "Medical Aid",
        "expertSubDomain": "Heart",
        "experience": "5 ",
       
        "availableSlots": "07:00 AM to 07:15 AM , 08:45 AM to 09:00 AM ",
        
        
    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,
        "expertName": "Dr. Mehta",
        "expertDomain": "Medical Aid",
        "expertSubDomain": "Heart",
        "experience": "5 ",
       
        "availableSlots": "07:00 AM to 07:15 AM , 08:45 AM to 09:00 AM ",
        
        
    },
    {
        "_id": "65a4c3bbaaca6c95458d8814",
        "expertImage": <img className="user-profile-img" src=' https://picsum.photos/200/300/?blur' />,
        "expertName": "Dr. Mehta",
        "expertDomain": "Medical Aid",
        "expertSubDomain": "Heart",
        "experience": "5 ",
       
        "availableSlots": "07:00 AM to 07:15 AM , 08:45 AM to 09:00 AM ",
        
        
    },
   
   
    
  ];
export const shiftFieldData = [
    {
        fieldDisplayName: "Shift Name",
        fieldName: "shiftName",
      },
    {
      fieldDisplayName: "Shift Start Timing",
      fieldName: "shiftStartTime",
    },
    {
      fieldDisplayName: "Shift End Timing",
      fieldName: "shiftEndTime",
    },
    {
      fieldDisplayName: "Slot Time",
      fieldName: "slotTime",
    },
   
    
  ];
export const shiftTableData = [
    
        {
            "_id": "65a4c3bbaaca6c95458d8814",
            "shiftName": "Morning Shift",
            "shiftStartTime": "07:00 AM",
            "shiftEndTime": "10:59 AM",
            "slotTime": "15 minutes",
            
        },
        {
            "_id": "65a4c3bbaaca6c95458d8814",
            "shiftName": "Afternoon Shift",
            "shiftStartTime": "11:00 PM",
            "shiftEndTime": "02:59 AM",
            "slotTime": "15 minutes",
            
        },
        {
            "_id": "65a4c3bbaaca6c95458d8814",
            "shiftName": "Evening Shift",
            "shiftStartTime": "03:00 PM",
            "shiftEndTime": "06:59 PM",
            "slotTime": "15 minutes",
            
        },
        {
            "_id": "65a4c3bbaaca6c95458d8814",
            "shiftName": "Night Shift",
            "shiftStartTime": "07:00 AM",
            "shiftEndTime": "09:59 AM",
            "slotTime": "30 minutes",

            
        },
      
    
   
    
  ];
  export const DegreeSpecialization =  [
    {_id : "18181918728",
       name:"MBBS",
       specialization:["Physician", "Gyneocologist", "nurologist"]

    },
    {_id: "23e979e8",
        name:"Law",
        specialization:["Civil", "Criminal"]

        

    },
    {_id:"98729b1xd18ee",
        name:"B.Tech",
        specialization:["CS", "Civil", "Mechanical","Electrical"]


    },
    {_id:"98729b1398754398ee",
        name:"B.Pharma",
        specialization:["catA", "catB", "catC"]


    },
    {_id:"98729b1398754398ee",
        name:"B.Arch",
        specialization:["Cat1", "Cat2", "Cat3"]


    },
    {_id:"98729b1398754398ee",
        name:"Other",
        specialization:"Other"


    },
    
  ];
  export const domainFieldsData = [
    {
        fieldDisplayName: "Domain Name",
        fieldName: "domainName",
      },
    {
        fieldDisplayName: "Sub-Domain Name",
        fieldName: "subDomainName",
      },
    
   
    
  ];
  export const degreeFieldData = [
    {
        fieldDisplayName: "Degree Name",
        fieldName: "degreeName",
      },
    // {
    //     fieldDisplayName: "Specialization Name",
    //     fieldName: "specialization",
    //   },
    ];
  export const degreeTableData = [
    {_id : "18181918728",
        degreeName:"MBBS",
        specialization:"Physician, Gyneocologist, nurologist"
 
     },
    {_id : "18181918728",
        degreeName:"Law",
        specialization:"Civil, Criminal"
 
     },
    {_id : "18181918728",
        degreeName:"B.Tech",
        specialization:"CS, Civil, Mechanical, Electrical"
 
     },
    {_id : "18181918728",
        degreeName:"B.Pharm",
        specialization:"Physician, Gyneocologist, nurologist"
 
     },
    {_id : "18181918728",
        degreeName:"B.Arch",
        specialization:"Cat1, Cat2, Cat3"
 
     },
    {_id : "18181918728",
        degreeName:"Other",
        specialization:"Other"
 
     },
    
    ];
    export const locationFieldData = [
      {
          fieldDisplayName: "Location Name",
          fieldName: "locationName",
        },
      {
          fieldDisplayName: "Address",
          fieldName: "address",
        },
      {
          fieldDisplayName: "District",
          fieldName: "districtName",
        },
      {
          fieldDisplayName: "State",
          fieldName: "stateName",
        },
      {
          fieldDisplayName: "Pincode",
          fieldName: "pincode",
        },
      ];
    export const stateDistrictFieldData = [
      {
          fieldDisplayName: "State Name",
          fieldName: "stateName",
        },
      {
          fieldDisplayName: "Districts Name",
          fieldName: "districts",
        },
      
      ];
  export const DomainSubDomain =  [
    {_id : "18181918728",
       domainName:"Medical Aid",
       ssubDomain:"Heart,Brain,Cancer,Liver,Skin,Kidney,Bones,Gastroentrology,Other Medical Help",
       subDomain:[{_id:"987hgiuhg",name:"Heart"},{_id:"987hgiuhg",name:"Brain"}, {_id:"987hgiuhg",name:"Cancer"}, {_id:"987hgiuhg",name:"Liver"},{_id:"987hgiuhg",name:"Skin"},{_id:"987hgiuhg",name:"Kidney"},{_id:"987hgiuhg",name:"Bones"},{_id:"987hgiuhg",name:"Gastroentrology"},{_id:"987hgiuhg",name: "Other Medical Help"}]

    },
    {_id: "23e979e8",
        domainName:"Legal Consultation",
        ssubDomain:"Property,Will,Trademark,Cheque Bounce,Crimainal Matter,Other Legal Guide",

        subDomain:[{_id:"987hgiuhg",name:"Property"}, {_id:"987hguhg",name:"Will"}, {_id:"987hgi7uhg",name:"Trademark"},{_id:"9887hgiuhg",name:"Cheque Bounce"},{_id:"987hgiu98hg",name:"Crimainal Matter"}, {_id:"987hghjiuhg",name:"Other Legal Guide"}]

        

    },
    {_id:"98729b1xd18ee",
        domainName:"Taxation Guide",
        ssubDomain:"GST,Corporate Tax,Income Tax,Other Taxation Tax",

        subDomain:[{_id:"987hgiuh89",name:"GST"}, {_id:"989j7hgiuhg",name:"Corporate Tax"}, {_id:"987huo8giuhg",name:"Income Tax"},{_id:"987hgibij8uhg",name:"Other Taxation Guide"}]


    },
    {_id:"98729b1398754398ee",
        domainName:"Career Conselling",
        ssubDomain:"Admissions,Institutes Tax,Placements,Other Carrer Query",

        subDomain:[{_id:"987hgiuhg",name:"Admissions"}, {_id:"987hgiuhg",name:"Institutes"}, {_id:"987hgiuhg",name:"Placements"},{_id:"987hgiuhg",name:"Other Carrer Query"}]


    },
    
    
  ];
  export const tpfMember =  [
    {_id : "18181918728",
       zone:"CENTRAL",
       branch:[
        {"branchName":"Ajmer-Kishangarh"},
        {"branchName":"Bhilwara"},
        {"branchName":"Bikaner"}, 
        {"branchName":"Chittorgarh"},
        {"branchName":"Hanumangarh"},
        {"branchName":"Indore"},
        {"branchName":"Jaipur"},
        {"branchName":"Jodhpur"},
        {"branchName": "Kota"},
        {"branchName": "Raisingh Nagar"},
        {"branchName": "Rajsamand"},
        {"branchName": "Ratlam"},
        {"branchName": "Sawai Madhopur"},
        {"branchName": "Sivanchi Malani "},
        {"branchName": "Udaipur"},
        {"branchName": "Ujjain- Barnagar"},
        {"branchName": "other"},
    ]

    },
    {_id : "18181918728",
       zone:"EASTZONE-1",
       branch:[
        {"branchName":"Biratnagar"},
        {"branchName":"Gulababag"}, 
        {"branchName":"Guwahati"},
         {"branchName":"Kishanganj"},
         {"branchName":"Kishanganj Secretary"},
         {"branchName":"Kolkata General "},
         {"branchName":"Kolkata Purbanchal "},
         {"branchName":"Kolkata South "},
         {"branchName":"North Howrah"},
         {"branchName":"Sainthia"},
         {"branchName":"Silchar"},
         {"branchName":"Siliguri"},
         {"branchName":"South Howrah"},
         {"branchName":"Balangir"},
         {"branchName":"Kantabanji"},
         {"branchName":"Kesinga"},
         {"branchName":"Raipur"},
         {"branchName":"Rajnandgaon"},
         {"branchName":"Rourkela"},
         {"branchName":"Tiliagarh"},
         {"branchName":"other"},
       
    ]

    },
    {_id : "18181918728",
       zone:"MUMBAI",
       branch:[
        {"branchName":"Mumbai Central"},
        {"branchName":"Mumbai City"}, 
        {"branchName":"Mumbai Western"},
         {"branchName":"Navi Mumbai"},
         {"branchName":"Palghar"},
         {"branchName":"Thane"},
         
    ]

    },
    {_id : "18181918728",
       zone:"NORTH",
       branch:[
        {"branchName":"Bhiwani"},
        {"branchName":"Delhi"}, 
        {"branchName":"Faridabad"},
         {"branchName":"Ghaziabad"},
         {"branchName":"Gurugram"},
         {"branchName":"Hisar"},
         {"branchName":"Jind"},
         {"branchName":"Kanpur"},
         {"branchName":"Ludhiana"},
         {"branchName":"Noida"},
         {"branchName":"Panchkula"},
         {"branchName":"Patiyala"},
         {"branchName":"Rohtak"},
         {"branchName":"Sangrur"},
         {"branchName":"Sirsa"},
         {"branchName":"Sangrur"},
         {"branchName":"Tohana"},
         {"branchName":"Varansi"},
         {"branchName":"Yamuna Nagar"},
         
    ]

    },
    {_id : "18181918728",
       zone:"SOUTH",
       branch:[
        {"branchName":"Bangalore"},
        {"branchName":"Chennai"}, 
        {"branchName":"Chikmagalur"},
        {"branchName":"Hyderabad"},
        {"branchName":"Mysore"},
        {"branchName":"Chikmagalur"},
        {"branchName":" Uttar Karnataka"},
        {"branchName":"Vishakapattanam"},
        
         
    ]

    },
    {_id : "18181918728",
       zone:"WEST",
       branch:[
        {"branchName":"Ahmedabad"},
        {"branchName":"Aurangabad"}, 
        {"branchName":"Bardoli"},
        {"branchName":"Bharuch-Ankleshwar"},
        {"branchName":"Gandhidham"},
        {"branchName":"Ichalkaranji"},
        {"branchName":"Jalgaon"},
        {"branchName":"Jalna"},
        {"branchName":"Kokan"},
        {"branchName":"Kutch- Bhuj"},
        {"branchName":"Latur"},
        {"branchName":"Nagpur"},
        {"branchName":"Nashik"},
        {"branchName":"Pimpri Chinchwad"},
        {"branchName":"Pune"},
        {"branchName":"Surat"},
        {"branchName":"Vadodara"},
        {"branchName":"Vapi"},
        {"branchName":"Yawatmal- Amarwati"},
        {"branchName":"other"},
       
        
         
    ]

    },
    {_id : "18hgjhk18728",
       zone:"OTHER",
       branch:[{_id:"987hgiu98jguhhg",name:"Other"},
        
       
        
         
    ]

    },
    
  ];
  export const expSlotAvailability = [

    {  
        date: "02 Dec 24",
        morningSlot:[{"status":"A","time":'7:00 AM'},{"status":"B","time":'7:15 AM'},{"status":"V","time":'7:30 AM'},{"status":"V","time":'7:45 AM'},{"status":"V","time":'8:00 AM'},{"status":"V","time":'8:15 AM'},{"status":"V","time":'8:30 AM'},{"status":"V","time":'8:45 AM'},{"status":"V","time":'9:00 AM'},{"status":"V","time":'9:15 AM'},{"status":"V","time":'9:30 AM'},{"status":"V","time":'9:45 AM'},{"status":"V","time":'10:00 AM'},{"status":"V","time":'10:15 AM'},{"status":"V","time":'10:30 AM'},{"status":"V","time":'10:45 AM'},{"status":"V","time":'11:00 AM'}],
        afternoonSlot:[{"status":"V","time":'11:01 AM'},{"status":"V","time":'11:15 AM'},{"status":"V","time":'7:30 AM'},{"status":"V","time":'7:45 AM'},{"status":"V","time":'8:00 AM'},{"status":"V","time":'8:15 AM'},{"status":"V","time":'8:30 AM'},{"status":"V","time":'8:45 AM'},{"status":"V","time":'9:00 AM'},{"status":"V","time":'9:15 AM'},{"status":"V","time":'9:30 AM'},{"status":"V","time":'9:45 AM'},{"status":"V","time":'10:00 AM'},{"status":"V","time":'10:15 AM'},{"status":"V","time":'10:30 AM'},{"status":"V","time":'10:45 AM'},{"status":"V","time":'11:00 AM'}],
        eveningSlot:[{"status":"V","time":'7:00 AM'},{"status":"V","time":'7:15 AM'},{"status":"V","time":'7:30 AM'},{"status":"V","time":'7:45 AM'},{"status":"V","time":'8:00 AM'},{"status":"V","time":'8:15 AM'},{"status":"V","time":'8:30 AM'},{"status":"V","time":'8:45 AM'},{"status":"V","time":'9:00 AM'},{"status":"V","time":'9:15 AM'},{"status":"V","time":'9:30 AM'},{"status":"V","time":'9:45 AM'},{"status":"V","time":'10:00 AM'},{"status":"V","time":'10:15 AM'},{"status":"V","time":'10:30 AM'},{"status":"V","time":'10:45 AM'},{"status":"V","time":'11:00 AM'}],
        nightSlot:[{"status":"V","time":'7:00 AM'},{"status":"V","time":'7:15 AM'},{"status":"V","time":'7:30 AM'},{"status":"V","time":'7:45 AM'},{"status":"V","time":'8:00 AM'},{"status":"V","time":'8:15 AM'},{"status":"V","time":'8:30 AM'},{"status":"V","time":'8:45 AM'},{"status":"V","time":'9:00 AM'},{"status":"V","time":'9:15 AM'},{"status":"V","time":'9:30 AM'},{"status":"V","time":'9:45 AM'},{"status":"V","time":'10:00 AM'},{"status":"V","time":'10:15 AM'},{"status":"V","time":'10:30 AM'},{"status":"V","time":'10:45 AM'},{"status":"V","time":'11:00 AM'}],
       
    },
    {  
        date: "03 Dec 24",
        morningSlot:[{"status":"A","time":'7:00 AM'},{"status":"B","time":'7:15 AM'},{"status":"V","time":'7:30 AM'},{"status":"V","time":'7:45 AM'},{"status":"V","time":'8:00 AM'},{"status":"V","time":'8:15 AM'},{"status":"V","time":'8:30 AM'},{"status":"V","time":'8:45 AM'},{"status":"V","time":'9:00 AM'},{"status":"V","time":'9:15 AM'},{"status":"V","time":'9:30 AM'},{"status":"V","time":'9:45 AM'},{"status":"V","time":'10:00 AM'},{"status":"V","time":'10:15 AM'},{"status":"V","time":'10:30 AM'},{"status":"V","time":'10:45 AM'},{"status":"V","time":'11:00 AM'}],
        afternoonSlot:[{"status":"V","time":'7:00 AM'},{"status":"V","time":'7:15 AM'},{"status":"V","time":'7:30 AM'},{"status":"V","time":'7:45 AM'},{"status":"V","time":'8:00 AM'},{"status":"V","time":'8:15 AM'},{"status":"V","time":'8:30 AM'},{"status":"V","time":'8:45 AM'},{"status":"V","time":'9:00 AM'},{"status":"V","time":'9:15 AM'},{"status":"V","time":'9:30 AM'},{"status":"V","time":'9:45 AM'},{"status":"V","time":'10:00 AM'},{"status":"V","time":'10:15 AM'},{"status":"V","time":'10:30 AM'},{"status":"V","time":'10:45 AM'},{"status":"V","time":'11:00 AM'}],
        eveningSlot:[{"status":"V","time":'7:00 AM'},{"status":"V","time":'7:15 AM'},{"status":"V","time":'7:30 AM'},{"status":"V","time":'7:45 AM'},{"status":"V","time":'8:00 AM'},{"status":"V","time":'8:15 AM'},{"status":"V","time":'8:30 AM'},{"status":"V","time":'8:45 AM'},{"status":"V","time":'9:00 AM'},{"status":"V","time":'9:15 AM'},{"status":"V","time":'9:30 AM'},{"status":"V","time":'9:45 AM'},{"status":"V","time":'10:00 AM'},{"status":"V","time":'10:15 AM'},{"status":"V","time":'10:30 AM'},{"status":"V","time":'10:45 AM'},{"status":"V","time":'11:00 AM'}],
        nightSlot:[{"status":"V","time":'7:00 AM'},{"status":"V","time":'7:15 AM'},{"status":"V","time":'7:30 AM'},{"status":"V","time":'7:45 AM'},{"status":"V","time":'8:00 AM'},{"status":"V","time":'8:15 AM'},{"status":"V","time":'8:30 AM'},{"status":"V","time":'8:45 AM'},{"status":"V","time":'9:00 AM'},{"status":"V","time":'9:15 AM'},{"status":"V","time":'9:30 AM'},{"status":"V","time":'9:45 AM'},{"status":"V","time":'10:00 AM'},{"status":"V","time":'10:15 AM'},{"status":"V","time":'10:30 AM'},{"status":"V","time":'10:45 AM'},{"status":"V","time":'11:00 AM'}],
       
    }
   
   
   
   
  

  ];

  export const datewiseActiveFields = [
    {
      fieldDisplayName: "Date",
      fieldName: "slotDate",
    },
    {
      fieldDisplayName: "Morning Slot",
      fieldName: "morningSlot",
    },
    {
      fieldDisplayName: "Afternoon Slot",
      fieldName: "afternoonSlot",
    },
    {
      fieldDisplayName: "Evening Slot",
      fieldName: "eveningSlot",
    },
   
    {
      fieldDisplayName: "Night Slot",
      fieldName: "nightSlot",
    },
    
  ];
  export const tableDumyData = [
    {
      "date":"18 Jan 2025",
      "morningShift":"10:00 AM, 10:30 AM",
      "afternoonShift":"1:00 PM,2:15 PM",
      "eveningShift":"4:15 PM, 4:30 PM, 5:30 PM",
      "nightShift":"8:15 PM",
    },
    {
      "date":"19 Jan 2025",
      "morningShift":"10:00 AM, 10:30 AM",
      "afternoonShift":"1:00 PM,2:15 PM",
      "eveningShift":"4:15 PM, 4:30 PM, 5:30 PM",
      "nightShift":"8:15 PM",
    },
    {
      "date":"20 Jan 2025",
      "morningShift":"10:00 AM, 10:30 AM",
      "afternoonShift":"1:00 PM,2:15 PM",
      "eveningShift":"4:15 PM, 4:30 PM, 5:30 PM",
      "nightShift":"8:15 PM",
    },
    {
      "date":"21 Jan 2025",
      "morningShift":"10:00 AM, 10:30 AM",
      "afternoonShift":"1:00 PM,2:15 PM",
      "eveningShift":"4:15 PM, 4:30 PM, 5:30 PM",
      "nightShift":"8:15 PM",
    },
   
   
    
    
  ];

  

